import { Stack } from '@mui/material';

import { FormTextField } from '@/components/form/formTextField';

import type { IntegrationWizardState } from '../integrationWizardFlow';

interface DatabricksConfigurationProps {
  wizardState: IntegrationWizardState;
  setWizardState: (
    updater: (state: IntegrationWizardState) => IntegrationWizardState
  ) => void;
}

export const DatabricksConfiguration = ({
  wizardState,
  setWizardState,
}: DatabricksConfigurationProps) => {
  return (
    <Stack className='w-[582px]' gap='24px'>
      <FormTextField
        title='Server hostname'
        placeholder='Example: http://46.116.201.233/'
        value={wizardState.config?.databricks?.serverHostname || ''}
        onChange={(event) =>
          setWizardState((state) => ({
            ...state,
            config: {
              ...state.config,
              databricks: {
                serverHostname: event.target.value,
                oauth2ClientId: state.config?.databricks?.oauth2ClientId || '',
              },
            },
          }))
        }
      />
      <FormTextField
        title='OAuth2 client ID'
        placeholder='Example: 5f69ce7b-0782-4fbc-b546-360babd1e94c'
        value={wizardState.config?.databricks?.oauth2ClientId || ''}
        onChange={(event) =>
          setWizardState((state) => ({
            ...state,
            config: {
              ...state.config,
              databricks: {
                oauth2ClientId: event.target.value,
                serverHostname: state.config?.databricks?.serverHostname || '',
              },
            },
          }))
        }
      />
    </Stack>
  );
};
